import type { InvestorProfileIncludes } from '@shared/utils'
import {
  ENDPOINTS,
  INCLUDES,
  QUERY_PARAMS,
  computeUrlWithQueryParameters,
} from '@shared/utils'
import { globalStoreForLogging } from 'src/App.utils'
import { jsonApi } from 'src/services/json-api/json-api.service'
import { handleJsonApiError } from 'src/services/json-api/json-api.utils'
import type { InvestorProfile } from 'src/tpbp-core/models/investor-profile/investor-profile.types'
import type {
  InvestorProfileApi,
  InvestorProfileIncludedApi,
} from 'src/tpbp-json-api-handler/investor-profile/investor-profile.api.types'
import type { RiskProfileModel } from 'src/tpbp-json-api-handler/models/models'

export async function getInvestorProfile(userId: string) {
  const endpoint = computeUrlWithQueryParameters(
    ENDPOINTS.investorProfile(userId),
    [INCLUDES.investorProfile()],
  )

  const response = await jsonApi.request<
    InvestorProfileApi,
    unknown,
    InvestorProfileIncludedApi[]
  >(endpoint, 'GET')

  if (response instanceof Error) return

  return response.document
}

export async function getInvestorProfileProxyRecord(
  userId: string,
  studyId?: string,
  includes?: InvestorProfileIncludes[],
): Promise<RiskProfileModel | undefined> {
  const endpoint = computeUrlWithQueryParameters(
    ENDPOINTS.investorProfile(userId),
    [QUERY_PARAMS.study(studyId), INCLUDES.investorProfile(includes)],
  )

  const response = await jsonApi.request<RiskProfileModel>(endpoint, 'GET')

  return handleJsonApiError(response)
}

export function extractMustUpdateQualificationFromInvestorProfile(
  investorProfile: Pick<InvestorProfile, 'mustUpdateQualification'>,
): boolean {
  const { mustUpdateQualification } = investorProfile ?? {}

  return !!mustUpdateQualification
}

export async function getInvestorProfileWithNoStudyAndLogging(
  userId: string,
): Promise<RiskProfileModel | undefined> {
  globalStoreForLogging().startLog('report-qualification-loadInvestorProfile2')

  const investorProfile = await getInvestorProfileProxyRecord(userId)

  globalStoreForLogging().endLog('report-qualification-loadInvestorProfile2')
  globalStoreForLogging().endGlobalLog()

  return investorProfile
}
